module.exports = __webpack_public_path__ + "static/img/组 2944.11c0c06.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/planandprepare/images/组 2944.png
// module id = EBed
// module chunks = 0